import { gql } from '@apollo/client';

export default gql`
  mutation CreateTeamsPriority($input: createTeamsPriorityInput!) {
    createTeamsPriority(input: $input) {
      count
    }
  }
`;
